module.exports = __webpack_public_path__ + "img/fooBath_empty.39785e33.png";